// ///////// V2
// ///////// V2
// ///////// V2
// ///////// V2
// ///////// V2


import styled, { css } from 'styled-components'
import BlurCont from 'Layout/BlurCont'
import PlaceHolder from 'Components/PlaceHolder'

import { CLICKABLE_COLOR, TEXT_GREY, LINK_COLOR, SELECTED_ITEM_BG_COLOR } from '@CSSVars/colors'


export const _Container = styled.div``

export const _BlockContainer = styled.div`
  div, a {
    font-size: 14px;
  }

  .smallExtra {
    font-size: 10px;
    white-space: normal;
    color: ${TEXT_GREY};
    @media screen and (max-width: 767px) {
      display: block;
    }
  }
`

export const _FlexContainer = styled.div`
  display: flex;
  a {
    color: ${CLICKABLE_COLOR};
    text-align: left;
  }
`

export const _InfoRowTitle = styled(BlurCont)`
  color: ${TEXT_GREY};
  margin-bottom: 2px;
  white-space: nowrap;
  line-height: 22px;

  ${_FlexContainer} & {
    line-height: 24px;
    white-space: normal;
    margin-bottom: 0;
  }
`

export const _InfoRowValue = styled(BlurCont)`
  div, a {
    font-weight: 600;
    line-height: 22px;
    text-wrap: auto;
  }
  a {
    color:${CLICKABLE_COLOR};
    text-decoration: underline;

    div {
      color: ${CLICKABLE_COLOR};
    }
  }
  @media (hover: hover){
    a:hover{
      color:${LINK_COLOR};
    }
  }
  a:active{
    color: ${SELECTED_ITEM_BG_COLOR};
  }
  ${_FlexContainer} & {
    a {
      font-size: 14px;
      div {
        font-size: 14px;
      }
    }
  }
`

const clickableMixin = css`
  color: ${CLICKABLE_COLOR};
  cursor: pointer;
  text-decoration: underline;
`

export const _ValueDiv = styled.div`
  white-space: pre;

  ${_FlexContainer} & {
    white-space: normal;
    line-height: 24px;
  }
  ${(props) => (props.clickable && clickableMixin) || ''}
  ${(props) => props.valueDivClassCss || ''}
`

export const _PlaceHolder = styled(PlaceHolder)`
  width: 90%;
  height: 15px;
`

